import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError as observableThrowError, Observable, of } from "rxjs";
import { BaseRestService } from "../base-rest.service";
import { ExportDataRequest } from "../../models/rest/export/export-data-request";
import { SessionStorageService } from "../session-storage.service";


@Injectable({
  providedIn: 'root'
})
export class ExportBackendService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }
  //Müşteri tipi ekle
  exportToFile(data) {
    const url = `/export`;
    return this.httpPost<ExportDataRequest>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  exportToExcel(data) {
    const url = `/export/excel`;
    return this.httpPost<ExportDataRequest>(url, data)
      .pipe(catchError(this.errorHandler));
  }


  exportToPdf(data) {
    const url = `/export/pdf`;
    return this.httpPost<ExportDataRequest>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    // console.log("service:"+error);
    return observableThrowError(error);
  }
}
